module.exports = __webpack_public_path__ + "static/media/lapita_text_03.c5cfd9b0.jpg";